import axiosClient from './axiosClient';
export default {
  list: (body, params) => axiosClient.post('/tickets', body, { params }),
  get: (id) => axiosClient.get(`/tickets/${id}`),
  create: (formData) =>
    axiosClient.post('/tickets/create', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  addMessage: (id, formData) =>
    axiosClient.post(`/tickets/${id}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),
  downloadAttachment: (ticketId, attachmentId) =>
    axiosClient.get(
      `/tickets/${ticketId}/attachments/${attachmentId}`,
      { responseType: 'blob' }
    ),
  changeStatus: (id,stato) => axiosClient.patch(`/tickets/${id}/status`, stato),
  changeLevel: (id,livello) => axiosClient.patch(`/tickets/${id}/livello`, livello),
};
